module.exports = __webpack_public_path__ + "static/media/ledmac_tagline.13fcf8a2.svg";